import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Button from '../Button';

export type plansDataProps = {
  name: string;
  price?: string;
};

export type customEstimatePlanProps = {
  breakdownData: plansDataProps[];
  pricesBreakdown?: boolean;
};

const ExpandableContentEstimatePlan = ({
  breakdownData,
  pricesBreakdown,
}: customEstimatePlanProps) => {
  const [breakdownDataStored, setBreakdownDataStored] =
    React.useState<plansDataProps[]>(breakdownData);

  useEffect(() => {
    if (breakdownData) {
      setBreakdownDataStored(breakdownData);
    }
  }, [breakdownDataStored, breakdownData]);

  return (
    <>
      {breakdownDataStored ? (
        <Container className="custom-estimate-plan-container">
          <Col lg={9} className="estimate-plan-col">
            <Col className="plan-container-col">
              {breakdownDataStored.map((item, index) => (
                <Row
                  className={`plans-row ${
                    index + 1 === breakdownDataStored.length ? 'last-row' : ''
                  }`}
                  key={index}
                >
                  <Col
                    xs={8}
                    className={`plan-col name-col plan-border plan-border-${
                      index + 1
                    }`}
                  >
                    {item.name}
                  </Col>
                  {pricesBreakdown && (
                    <>
                      {item.price && (
                        <Col xs={4} className="plan-col price-col">
                          {item.price}
                        </Col>
                      )}
                    </>
                  )}
                </Row>
              ))}
            </Col>
            {!pricesBreakdown && (
              <Col>
                <Row className="info-row">
                  <Col xs={8} className="info-col">
                    use the compare plan tools to get breakdown
                  </Col>
                  <Col xs={4}></Col>
                </Row>
              </Col>
            )}
          </Col>
          <Col lg={3}>
            <Row className="btn-row">
              <Container className="btn-container">
                <Button
                  variant="primary"
                  rightIcon={light('file-pdf')}
                  size="sm"
                  href={`${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`}
                  target={'_blank'}
                >
                  Plan Details
                </Button>
              </Container>
            </Row>
          </Col>
        </Container>
      ) : (
        <h1>NO DATA</h1>
      )}
    </>
  );
};

export default ExpandableContentEstimatePlan;
